import { render, staticRenderFns } from "./ElementsSidebar.vue?vue&type=template&id=60afc3f4&scoped=true"
import script from "./ElementsSidebar.vue?vue&type=script&lang=js"
export * from "./ElementsSidebar.vue?vue&type=script&lang=js"
import style0 from "./ElementsSidebar.vue?vue&type=style&index=0&id=60afc3f4&prod&lang=scss&scoped=true"
import style1 from "./ElementsSidebar.vue?vue&type=style&index=1&id=60afc3f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60afc3f4",
  null
  
)

export default component.exports